import { AccountService } from '../../../services/account.service';
import { CommonModule, NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ReportKappaComponent } from '../report-kappa/report-kappa.component';
import { ReportAbstractSummaryComponent } from '../report-abstract-summary/report-abstract-summary.component';
import { ReportAbstractValuesComponent } from '../report-abstract-values/report-abstract-values.component';
//import { ReportWeeklyCoderComponent } from '../report-weekly-coder/report-weekly-coder.component';
import { ReportWeeklyCoderConsensusComponent } from '../report-weekly-coder-consensus/report-weekly-coder-consensus.component';
import { ReportReconCompletedComponent } from '../report-recon-completed/report-recon-completed.component';

@Component({
  selector: 'app-reports-home',
  templateUrl: './reports-home.component.html',
  styleUrls: ['./reports-home.component.css'],
  imports: [
    CommonModule,
    MatButtonModule,
    NgClass,
    ReportKappaComponent,
    ReportAbstractSummaryComponent,
    ReportAbstractValuesComponent,
    //ReportWeeklyCoderComponent,
    ReportWeeklyCoderConsensusComponent,
    ReportReconCompletedComponent
  ]
})
export class ReportsHomeComponent implements OnInit {

  reportId: number = 0;
  activeProjectTitle: string;

  constructor(
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.activeProjectTitle = this.accountService.GetActiveProject().projectTitle;
  }

  selectReport(reportISelected: number) {
    this.reportId = reportISelected;
  }
}
